module.exports = __webpack_public_path__ + "static/media/ooops.75928c68.png";